import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICompanyMemberState } from '../types/company-member';
import { getCompanyMembersThunk } from '../thunks/companyMemberThunk';
import { ICompanyMemberResponse } from '@/shared/services/interface/responses/ICompanyResponses';

const initialState: ICompanyMemberState = {
  members: [],
  pendingInvites: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    limit: 10,
    nextOffset: 0,
    hasNext: false,
    hasPrevious: false,
  },
};

export const companyMemberSlice = createSlice({
  name: 'companyMember',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    clearCompanyMembers: (state) => {
      state.members = [];
      state.pendingInvites = [];
      state.pagination = initialState.pagination;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyMembersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyMembersThunk.fulfilled, (state, action: PayloadAction<ICompanyMemberResponse>) => {
        state.loading = false;
        state.members = action.payload.members;
        state.pendingInvites = action.payload.pendingInvites;
        state.pagination = action.payload.pagination;
        state.error = null;
      })
      .addCase(getCompanyMembersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading, clearCompanyMembers } = companyMemberSlice.actions;

export default companyMemberSlice.reducer; 